import React, { useEffect } from 'react';
import SEO from '../utils/SEO';
import BannerBlock from '../components/complex/bannerBlock/bannerBlock';
import '../assets/styles/pages/_press.scss';
import PressConcertList from '../components/complex/pressConcertList/pressConcertList';
import { userActions } from '../redux/actions';
import { connect } from 'react-redux';
import { startLoader } from '../components/common/Loader';

const Press = (props) => {
  useEffect(() => {
    props.getMeta('Press');
    startLoader();
    props.getPressData();
  }, []);

  const metaData = props.metaData?.res;
  const concerts = props.pressData?.items?.res?.data;
  const banner = props.pressData?.items?.res?.banner;
  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />
      <BannerBlock
        data={banner && banner}
        pageName='pressBanner'
        fullHeight
        color='white'
        position='left'
        pressPage
      />
      <PressConcertList concerts={concerts && concerts} />
    </>
  );
};

function mapState (state) {
  return {
    pressData: state.getPress,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getPressData: userActions.getPressData,
  getMeta: userActions.getMetaData,
};
Press.fetchMeta = () => actionCreators.getMeta('Press');
Press.serverFetch = actionCreators.getPressData;

export default connect(mapState, actionCreators)(Press);
